// View not traced on the UI - Need discussion with QA team

import React from 'react';
import { connect } from 'react-redux';
import { Image } from 'semantic-ui-react';
import { redirectToPageFeatureUnavailable } from '../actions/shared';
import { queueESEvents, ESEventTypes } from 'businessLogic/logEventToElasticSearch';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);
@connect(mapStateToProps)
export default class FeatureUnavailablePage extends React.Component {
  constructor(props, ownProps) {
    super(props);
  }

  componentDidMount() {
    // When this page is accessed directly from url, then should set redirectToPageFeatureUnavailable to true
    if (this.props.dispatch) {
      this.props.dispatch(redirectToPageFeatureUnavailable(true));
    }
    queueESEvents(ESEventTypes.UpgradePlanPageShown, true);
  }
  componentWillUnmount() {
    if (this.props.dispatch) {
      this.props.dispatch(redirectToPageFeatureUnavailable(false));
    }
  }

  render() {
    let portalDefaultSupportEmailAddress = this.props.portalDefaultSupportEmail
      ? 'mailto:' + this.props.portalDefaultSupportEmail
      : '';
    let portalDefaultSupportEmailTest = this.props.portalDefaultSupportEmail
      ? this.props.portalDefaultSupportEmail
      : '';
    return (
      <div className="main-ui-container not-found-page waiting-area-view-all" data-rendered-as-container="false">
        <div className="not-found-img">
          <img
            className="ui image mrbxl mrtl logo-image"
            src={APP.IMAGES.UmbrellaLogo.default}
            style={{ margin: 'auto' }}
          />
        </div>
        <h1>{APP.LANGUAGE.FeatureUnavailablePage.MainHeading}</h1>
        <p>
          {htmlToReactParser.parse(
            xss(
              APP.LANGUAGE.FeatureUnavailablePage.Paragraph.replace(
                '##supportEmail##',
                `<a href=${portalDefaultSupportEmailAddress}>${portalDefaultSupportEmailTest}</a>`
              ).replace('##VideoCallPlatformName##', window.APP.CONFIGURATION.PORTAL.VideoCallPlatformName)
            )
          )}
        </p>
        <div className="display-flex center-flex mrtl mrbm" style={{ maxWidth: '750px', margin: 'auto' }}>
          <Image className="feature-subscription-plan" src={window.APP.IMAGES.SubscriptionPlan.default} fluid />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    portalDefaultSupportEmail: state.usersReducer.userProfile.portalDefaultSupportEmail,
    redirectToPageFeatureUnavailable: state.sharedReducer.redirectToPageFeatureUnavailable,
  };
}
